import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sales-horizon-chart" }
const _hoisted_2 = { class: "row g-2 mb-3" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "sales-horizon-chart__stat rounded-2 h-100" }
const _hoisted_5 = { class: "small text-muted text-nowrap" }
const _hoisted_6 = { class: "fw-semibold" }
const _hoisted_7 = { class: "sales-horizon-chart__stat rounded-2 h-100" }
const _hoisted_8 = { class: "small text-muted text-nowrap" }
const _hoisted_9 = { class: "fw-semibold" }
const _hoisted_10 = { class: "small text-muted text-nowrap" }
const _hoisted_11 = { class: "sales-horizon-chart__canvas" }
const _hoisted_12 = { ref: "canvas" }
const _hoisted_13 = { class: "sales-horizon-chart__legend d-flex flex-wrap justify-content-center mt-2" }
const _hoisted_14 = { class: "text-nowrap" }
const _hoisted_15 = { class: "text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.chart.totalLabel), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.chart.total), 1)
        ])
      ]),
      (_ctx.chart.saleModes.length > 1)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.chart.saleModes, (saleMode, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: saleMode.days,
              class: "col"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", {
                    class: "sales-horizon-chart__symbol sales-horizon-chart__symbol--column",
                    style: _normalizeStyle({background: _ctx.toneOf(index)})
                  }, null, 4),
                  _createTextVNode(_toDisplayString(saleMode.days), 1)
                ]),
                _createElementVNode("div", _hoisted_9, _toDisplayString(saleMode.share) + " %", 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(saleMode.note), 1)
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("canvas", _hoisted_12, null, 512)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("span", _hoisted_14, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "sales-horizon-chart__symbol sales-horizon-chart__symbol--estimate" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.chart.averageNote), 1)
      ]),
      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.chart.range), 1)
    ])
  ]))
}